export function getWebsiteMetadata(state) {
  return state.WebsiteMetadata;
}
